import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TemplateEngineState } from './TemplateEngine.types';

export const initialState: TemplateEngineState = {
  isModalOpen: false,
};

export const TemplateEngineReducer = createSlice({
  name: 'templateEngine',
  initialState,
  reducers: {
    setModalStatus: (state, action: PayloadAction<{ value: boolean }>) => {
      state.isModalOpen = action.payload.value;
    },
  },
});

export const { setModalStatus } = TemplateEngineReducer.actions;

export default TemplateEngineReducer.reducer;